import React, { useEffect } from 'react';
import './index.css';
import * as PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import logo from '../../assets/logo-mini.svg';
import withRouter from '../../components/WithRouter';
import ProfilePopover from './ProfilePopover';
import CreateNewCollectionDialog from '../CreateAssets/Video/MintNFT/CreateNewCollectionDialog';
import UploadFilesDialog from './UploadFilesDialog';
import CreatePopover from './CreatePopover';
import AppsPopover from './AppsPopover';
// import CreatePollDialog from '../Polls/CreatePoll';
// import CircularProgress from '../../components/CircularProgress';
import PreviewDialog from '../CreateAssets/Video/SourceType/PreviewDialog';
import ClassNames from 'classnames';
import { Menu } from '@material-ui/icons';
import { Button } from '@mui/material';
import cancelIcon from '../../assets/interactive/close.svg';
import AppsEcosystem from './appsEcoSystem';
import AssetPublishDialog from '../AssetPublish/Publish/PublishDialog';
import ChannelCreationDialog from '../InteractiveVideo/Publish/LeftSection/ChannelCreationDialog';
import ChannelMigrationDialog from '../Channel/ChannelInfo/Migration';
import { fetchChannelContractAddress } from '../../actions/channelContract';
import { connect } from 'react-redux';

const NavBar = (props) => {
    const [overlay, setOverlay] = React.useState(false);

    useEffect(() => {
        if ((!props.channelContractAddress || (typeof props.channelContractAddress === 'object' &&
            Object.keys(props.channelContractAddress).length === 0)) && !props.channelContractAddressInProgress) {
            props.fetchChannelContractAddress();
        }
    }, [props.channelContractAddress]);

    const handleOpen = () => {
        setOverlay(!overlay);
    };

    return (
        <div className="nav_bar">
            <IconButton
                className="logo_button"
                onClick={() => props.router.navigate('/dashboard')}>
                <img alt="logo" height="45" src={logo} width="100"/>
            </IconButton>
            <div className={ClassNames('right_nav', overlay ? 'show' : '')}>
                <div className="cancel" onClick={handleOpen}>
                    <img alt="CancelIcon" src={cancelIcon}/>
                </div>
                {/* <IconButton className="icon_button"> */}
                {/*    <Icon */}
                {/*        className="search" */}
                {/*        icon="search"/> */}
                {/* </IconButton> */}
                {/* <NotificationsPopover/> */}
                <CreatePopover/>
                <AppsPopover/>
                <ProfilePopover handleOverlay={setOverlay}/>
                <AppsEcosystem/>
                <Button
                    aria-label="Open drawer"
                    className={ClassNames('overlay_section', overlay ? 'hide' : '')}
                    color="inherit"
                    onClick={handleOpen}>
                    <Menu/>
                </Button>
            </div>
            <UploadFilesDialog/>
            <CreateNewCollectionDialog/>
            <PreviewDialog/>
            <AssetPublishDialog/>
            <ChannelCreationDialog/>
            <ChannelMigrationDialog/>
        </div>
    );
};

NavBar.propTypes = {
    channelContractAddress: PropTypes.object.isRequired,
    channelContractAddressInProgress: PropTypes.bool.isRequired,
    fetchChannelContractAddress: PropTypes.func.isRequired,
    router: PropTypes.shape({
        navigate: PropTypes.func.isRequired,
    }),
};

const stateToProps = (state) => {
    return {
        channelContractAddress: state.channelContract.channelContractAddress.value,
        channelContractAddressInProgress: state.channelContract.channelContractAddress.inProgress,
    };
};

const actionToProps = {
    fetchChannelContractAddress,
};

export default withRouter(connect(stateToProps, actionToProps)(NavBar));
